import moment from "moment";

export function getMaxDate() {
  const date = Date.now();
  return moment(new Date(date)).add(24, "hours");
}

export function getMinDate() {
  const date = Date.now();
  const dt = moment(new Date(date)).subtract(3, "year");
  const prevYear = dt.format("YYYY");
  return moment(prevYear).startOf("year");
}
